<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, WrapperColumnContent, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)
</script>

<template>
  <DashboardWidgetBase
    v-bind="props"
    v-on="emitHandlers"
    borderCssClasses="border-warning border-opacity-100"
  >
    <WrapperColumnContent>
      <div class="dashboard-number number-xl text-warning">$8,450</div>
      <div class="text-sm">Overdue: $1,200</div>
    </WrapperColumnContent>
  </DashboardWidgetBase>
</template>
